'use strict';

const React = require('react');
const ReactRouter = require('react-router');
const Route = ReactRouter.Route;
const IndexRoute = ReactRouter.IndexRoute;

// Polyfill on node for Webpack's code splitting
if (typeof require.ensure !== 'function')
    require.ensure = (_deps, callback) => callback(require);

module.exports = (
    <Route path="/" component={require('./index')}>
        <IndexRoute
            getComponent={(_next, callback) => require.ensure([], require => callback(null, require('./home')))}
        />
        <Route
            path="p/:id"
            getComponent={(_next, callback) => require.ensure([], require => callback(null, require('./comment')))}
        />
    </Route>
);



/** WEBPACK FOOTER **
 ** ./common/routes.js
 **/